import React from 'react';
import { Field } from 'redux-form';
import Typography from '@material-ui/core/Typography';

import Fields from 'components/Fields';
import { wizardStyles } from 'components/Forms/Wizard/wizardUtils';
import { useFormatMessage } from 'components/IntlProvider';

interface CategoryType {
  id: number;
  category: string;
  en_category: string;
}

interface SubcategoryProps {
  subcategories: CategoryType[];
  category: CategoryType;
}

const Subcategory = ({ subcategories, category }: SubcategoryProps) => {
  const classes = wizardStyles();
  const t = useFormatMessage();
  return (
    <>
      <Typography
        component="h2"
        variant="subtitle1"
        color="inherit"
        className={classes.subtitle}
      >
        {t(
          'fields.wizard.subcategory.p1',
          'You have indicated that you want to test a product from'
        )}{' '}
        <b>{category.en_category}</b>{' '}
        {t(
          'fields.wizard.subcategory.p2',
          'category. Which of the following categories best matches your test product?'
        )}
      </Typography>
      <Field
        fullWidth
        component={Fields.RadioGroup}
        options={subcategories}
        name="subcategory"
      />
    </>
  );
};

export default Subcategory;
